import { Box, Typography } from '@mui/material';
import { getBuddhistYear } from '@Utils/datetime';
import dayjs from 'dayjs';
import { GasEmissionUnit } from './GasEmissionMessage';

type BaseYearMessageProps = {
  year?: number;
  gasEmissionQuantity?: number;
};

const BaseYearMessage = (props: BaseYearMessageProps) => {
  const { year, gasEmissionQuantity } = props;

  if (!year && !gasEmissionQuantity) {
    return '-';
  }

  const baseYear = year ? dayjs(year) : null;
  const formattedYear = baseYear ? baseYear.year() : undefined;
  const quantity = gasEmissionQuantity
    ? Intl.NumberFormat('en').format(gasEmissionQuantity)
    : '-';
  const buddhistYear = formattedYear
    ? `${getBuddhistYear(formattedYear)}:`
    : '';
  const isYear = formattedYear ? `${formattedYear}:` : '';

  return (
    <Box>
      <Typography>
        {buddhistYear} ปล่อยก๊าซเรือนกระจก {quantity} <GasEmissionUnit />
      </Typography>
      <Typography mt={2}>
        {isYear} Greenhouse gas emissions {quantity} <GasEmissionUnit />
      </Typography>
    </Box>
  );
};

export default BaseYearMessage;
